<script setup>
import {Head, Link} from '@inertiajs/vue3';
import StoreLayout from '@/Layouts/StoreLayout.vue';
import Detail from "@/Pages/Product/Partials/Detail.vue";
import Row from "@/Pages/Product/Partials/Row.vue";
import Container from "@/Components/Container.vue";
import {onMounted} from "vue";
import {imageSize,productAsAnalyticItem} from "@/mixins";
import {event} from "vue-gtag";
import {PhArrowLeft} from '@phosphor-icons/vue';

const props = defineProps({
    product: Object,
    fabricLineProducts: Array,
    relatedProducts: Array,
    relatedProductsLink: String,
    browsePath: String,
    browseTitle: String,
});

const fabricLineTitle = props.product.details.fabricLine ? "More from " + props.product.details.fabricLine.name : "";

onMounted(() => {
    setTimeout(() => {
        event('view_item', {
            currency: "USD",
            value: props.product.price / 100,
            items: [productAsAnalyticItem(props.product, 0)],
        });
    }, 100);
});

</script>

<template>
    <Head>
        <title>{{ product.title }}</title>
        <meta property="og:title" :content="product.title">
        <meta property="og:image" :content="imageSize(product.imageSrc, 300)">
        <meta property="og:site_name" content="Old Country Store Fabrics">
    </Head>

    <StoreLayout>
        <Container>
            <Link v-if="browsePath" :href="browsePath"
                  class="inline-flex items-center gap-1 text-sm text-gray-600 hover:text-gray-900 mb-4">
                <PhArrowLeft class="h-4 w-4" />
                Back to {{ browseTitle }}
            </Link>
            <div v-if="!product.currentProduct" class="mb-20">
                <div class="mx-auto w-full max-w-2xl flex flex-row items-center">
                    <img :src="imageSize(product.imageSrc, 300)" :alt="product.name" class="rounded-lg w-20 h-20"/>
                    <p class="ml-4 tracking-tight text-gray-900">{{
                            product.title
                        }}{{ product.details.manufacturer ? ' by ' + product.details.manufacturer.name : '' }} is no
                        longer available.</p>
                </div>
                <Row title="Similar Products" :products="relatedProducts" :link="relatedProductsLink"/>
                <Row v-if="product.details.fabricLine && fabricLineProducts.length > 1" :title="fabricLineTitle"
                     :products="fabricLineProducts"
                     :link="product.details.fabricLine.url"/>
            </div>
            <Detail :product="product"/>
            <template v-if="product.currentProduct">
                <Row v-if="product.details.fabricLine" :title="fabricLineTitle" :products="fabricLineProducts"
                     :link="product.details.fabricLine.url"/>
                <Row title="Similar Products" :products="relatedProducts" :link="relatedProductsLink"/>
            </template>
        </Container>
    </StoreLayout>
</template>
